import {Spinner as TPASpinner} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React from 'react'
import {SpinnerProps} from './interfaces'
import {classes} from './spinner.st.css'

export const Spinner = ({
  className,
  calendar,
  calendarButton,
  mobileList,
  calendarCategoryPickerButton,
  ...rest
}: SpinnerProps) => (
  <TPASpinner
    {...rest}
    className={classNames(
      mobileList
        ? classes.mobileList
        : calendar
        ? classes.calendar
        : calendarButton
        ? classes.calendarButton
        : calendarCategoryPickerButton
        ? classes.calendarCategoryPickerButton
        : classes.list,
      className,
    )}
  />
)
